import React, { useState } from "react";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledCtaText from "../../../common/components/styledCtaText/StyledCtaText";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";

import { Link } from "react-router-dom";

const ConnectingModal = ({
  closeModal,
  handleSignUp,
  setUserName,
  setEmail,
  userName,
  email,
}) => {
  const [emailError, setEmailError] = useState("");
  const [isTermsChecked, setIsTermsChecked] = useState();
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError("");
    }
  };
  const validateEmail = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setEmailError("Please type a valid email");
      return false;
    }
    setEmailError("");
    return true;
  };
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const isValidEmail = emailRegex.test(email);
  const isFormValid =
    userName.trim() !== "" &&
    email.trim() !== "" &&
    isTermsChecked &&
    isValidEmail;
  const handleSubmit = () => {
    if (!validateEmail()) return;
    handleSignUp(email, userName);
  };
  const handleSkip = () => {
    closeModal();
  };
  return (
    <NftInteractionModal
      outsideClick={false}
      custom
      width={"w-[95%] sm:w-4/5 md:w-4/6 lg:w-1/2 xl:w-[30%]"}
      content={
        <div className="w-full flex flex-col justify-center items-center gap-6 p-5 sm:p-10">
          <div className="w-full text-center">
            <StyledH4Heading fontColor={"textGradient"}>
              You Are Almost There!
            </StyledH4Heading>
            <StyledMdText>
              Choose a display name and enter your email address to receive
              updates about new NFTs and other super offers
            </StyledMdText>
          </div>
          <div className="w-full flex flex-col gap-4">
            <div className="relative w-full md:w-[95%] min-w-[200px] h-12">
              <input
                type="text"
                placeholder="User Name"
                value={userName}
                maxLength={30}
                onChange={(e) => setUserName(e.target.value)}
                className={`w-full h-full bg-transparent outline-0 text-md border focus:border-1 border-bright-yellow rounded-[7px] focus:border-bright-yellow pl-4`}
              />
            </div>
            <div className="relative w-full md:w-[95%] min-w-[200px] h-12">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
                onBlur={validateEmail}
                maxLength={40}
                className="w-full h-full bg-transparent outline-0 text-md border focus:border-1 border-bright-yellow rounded-[7px] focus:border-bright-yellow pl-4"
              />
              {email.length > 0 && !isValidEmail && (
                <p className="text-bright-yellow text-sm mt-1">
                  Please type a valid email
                </p>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex gap-4 ">
              <div className="mt-1">
                <input
                  id="default-checkbox"
                  type="checkbox"
                  checked={isTermsChecked}
                  onChange={(e) => setIsTermsChecked(e.target.checked)}
                  className="w-[18px] h-[18px]"
                />
              </div>
              <label htmlFor="default-checkbox">
                <StyledMdText>
                  I have read and accept the
                  <Link
                    target="_blank"
                    to="/terms-and-conditions"
                    className="text-bright-yellow "
                  >
                    {" "}
                    Terms & Conditions{" "}
                  </Link>{" "}
                  Terms and Conditions of Service and
                  <Link
                    target="_blank"
                    to="/privacy-policy"
                    className="text-bright-yellow"
                  >
                    {" "}
                    Privacy Policy{" "}
                  </Link>
                  of Golden Years Coin.
                </StyledMdText>
              </label>
            </div>
            <div className="flex gap-4 ">
              <div className="mt-1">
                <input
                  id="default-checkbox2"
                  type="checkbox"
                  className="w-[18px] h-[18px]"
                />
              </div>
              <label htmlFor="default-checkbox2">
                <StyledMdText>
                  I want to receive announcements and news from Golden Years to
                  stay up to date with the NFT Market.
                </StyledMdText>
              </label>
            </div>
          </div>
          <div className="w-full flex flex-col items-center gap-4">
            <GradientButton
              fontColor={"w-full"}
              disabled={!isFormValid}
              children={"Finish sign-up"}
              onClick={handleSubmit}
              type="button"
            />
            <button type="button" onClick={handleSkip}>
              <StyledCtaText>Skip for Now</StyledCtaText>
            </button>
          </div>
        </div>
      }
    />
  );
};

export default ConnectingModal;
